/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Proration_DescriptionInputs */



/**
* | output |
* | --- |
* | "Prorated charges for seats added mid-billing cycle" |
*
* @param {Billing_Proration_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_proration_description = /** @type {((inputs?: Billing_Proration_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Proration_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anteilige Gebühren für Plätze, die während des Abrechnungszeitraums hinzugefügt wurden")
	return /** @type {LocalizedString} */ ("Prorated charges for seats added mid-billing cycle")
});